import _defineProperty from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/createClass.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/regenerator/index.js";
import { decodeJWT, assertTokenProviderConfig } from '@aws-amplify/core/internals/utils';
import { AuthError } from '../../../errors/AuthError.mjs';
import { AuthTokenStorageKeys } from './types.mjs';
import { assert, TokenProviderErrorCode } from './errorHelpers.mjs';

var DefaultTokenStore = /*#__PURE__*/function () {
  function DefaultTokenStore() {
    _classCallCheck(this, DefaultTokenStore);

    this.name = 'CognitoIdentityServiceProvider'; // To be backwards compatible with V5, no migration needed
  }

  _createClass(DefaultTokenStore, [{
    key: "getKeyValueStorage",
    value: function getKeyValueStorage() {
      if (!this.keyValueStorage) {
        throw new AuthError({
          name: 'KeyValueStorageNotFoundException',
          message: 'KeyValueStorage was not found in TokenStore'
        });
      }

      return this.keyValueStorage;
    }
  }, {
    key: "setKeyValueStorage",
    value: function setKeyValueStorage(keyValueStorage) {
      this.keyValueStorage = keyValueStorage;
    }
  }, {
    key: "setAuthConfig",
    value: function setAuthConfig(authConfig) {
      this.authConfig = authConfig;
    }
  }, {
    key: "loadTokens",
    value: function () {
      var _loadTokens = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _yield$this$getKeyVal, _yield$this$getKeyVal2, _yield$this$getDevice, authKeys, accessTokenString, accessToken, itString, idToken, refreshToken, clockDriftString, clockDrift, signInDetails, tokens;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.getAuthKeys();

              case 3:
                authKeys = _context.sent;
                _context.next = 6;
                return this.getKeyValueStorage().getItem(authKeys.accessToken);

              case 6:
                accessTokenString = _context.sent;

                if (accessTokenString) {
                  _context.next = 9;
                  break;
                }

                throw new AuthError({
                  name: 'NoSessionFoundException',
                  message: 'Auth session was not found. Make sure to call signIn.'
                });

              case 9:
                accessToken = decodeJWT(accessTokenString);
                _context.next = 12;
                return this.getKeyValueStorage().getItem(authKeys.idToken);

              case 12:
                itString = _context.sent;
                idToken = itString ? decodeJWT(itString) : undefined;
                _context.next = 16;
                return this.getKeyValueStorage().getItem(authKeys.refreshToken);

              case 16:
                _context.t1 = _yield$this$getKeyVal = _context.sent;
                _context.t0 = _context.t1 !== null;

                if (!_context.t0) {
                  _context.next = 20;
                  break;
                }

                _context.t0 = _yield$this$getKeyVal !== void 0;

              case 20:
                if (!_context.t0) {
                  _context.next = 24;
                  break;
                }

                _context.t2 = _yield$this$getKeyVal;
                _context.next = 25;
                break;

              case 24:
                _context.t2 = undefined;

              case 25:
                refreshToken = _context.t2;
                _context.next = 28;
                return this.getKeyValueStorage().getItem(authKeys.clockDrift);

              case 28:
                _context.t4 = _yield$this$getKeyVal2 = _context.sent;
                _context.t3 = _context.t4 !== null;

                if (!_context.t3) {
                  _context.next = 32;
                  break;
                }

                _context.t3 = _yield$this$getKeyVal2 !== void 0;

              case 32:
                if (!_context.t3) {
                  _context.next = 36;
                  break;
                }

                _context.t5 = _yield$this$getKeyVal2;
                _context.next = 37;
                break;

              case 36:
                _context.t5 = '0';

              case 37:
                clockDriftString = _context.t5;
                clockDrift = Number.parseInt(clockDriftString);
                _context.next = 41;
                return this.getKeyValueStorage().getItem(authKeys.signInDetails);

              case 41:
                signInDetails = _context.sent;
                _context.t6 = accessToken;
                _context.t7 = idToken;
                _context.t8 = refreshToken;
                _context.next = 47;
                return this.getDeviceMetadata();

              case 47:
                _context.t10 = _yield$this$getDevice = _context.sent;
                _context.t9 = _context.t10 !== null;

                if (!_context.t9) {
                  _context.next = 51;
                  break;
                }

                _context.t9 = _yield$this$getDevice !== void 0;

              case 51:
                if (!_context.t9) {
                  _context.next = 55;
                  break;
                }

                _context.t11 = _yield$this$getDevice;
                _context.next = 56;
                break;

              case 55:
                _context.t11 = undefined;

              case 56:
                _context.t12 = _context.t11;
                _context.t13 = clockDrift;
                _context.next = 60;
                return this.getLastAuthUser();

              case 60:
                _context.t14 = _context.sent;
                tokens = {
                  accessToken: _context.t6,
                  idToken: _context.t7,
                  refreshToken: _context.t8,
                  deviceMetadata: _context.t12,
                  clockDrift: _context.t13,
                  username: _context.t14
                };

                if (signInDetails) {
                  tokens.signInDetails = JSON.parse(signInDetails);
                }

                return _context.abrupt("return", tokens);

              case 66:
                _context.prev = 66;
                _context.t15 = _context["catch"](0);
                return _context.abrupt("return", null);

              case 69:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 66]]);
      }));

      function loadTokens() {
        return _loadTokens.apply(this, arguments);
      }

      return loadTokens;
    }()
  }, {
    key: "storeTokens",
    value: function () {
      var _storeTokens = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(tokens) {
        var lastAuthUser, authKeys;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                assert(tokens !== undefined, TokenProviderErrorCode.InvalidAuthTokens);
                _context2.next = 3;
                return this.clearTokens();

              case 3:
                lastAuthUser = tokens.username;
                _context2.next = 6;
                return this.getKeyValueStorage().setItem(this.getLastAuthUserKey(), lastAuthUser);

              case 6:
                _context2.next = 8;
                return this.getAuthKeys();

              case 8:
                authKeys = _context2.sent;
                _context2.next = 11;
                return this.getKeyValueStorage().setItem(authKeys.accessToken, tokens.accessToken.toString());

              case 11:
                if (!tokens.idToken) {
                  _context2.next = 14;
                  break;
                }

                _context2.next = 14;
                return this.getKeyValueStorage().setItem(authKeys.idToken, tokens.idToken.toString());

              case 14:
                if (!tokens.refreshToken) {
                  _context2.next = 17;
                  break;
                }

                _context2.next = 17;
                return this.getKeyValueStorage().setItem(authKeys.refreshToken, tokens.refreshToken);

              case 17:
                if (!tokens.deviceMetadata) {
                  _context2.next = 26;
                  break;
                }

                if (!tokens.deviceMetadata.deviceKey) {
                  _context2.next = 21;
                  break;
                }

                _context2.next = 21;
                return this.getKeyValueStorage().setItem(authKeys.deviceKey, tokens.deviceMetadata.deviceKey);

              case 21:
                if (!tokens.deviceMetadata.deviceGroupKey) {
                  _context2.next = 24;
                  break;
                }

                _context2.next = 24;
                return this.getKeyValueStorage().setItem(authKeys.deviceGroupKey, tokens.deviceMetadata.deviceGroupKey);

              case 24:
                _context2.next = 26;
                return this.getKeyValueStorage().setItem(authKeys.randomPasswordKey, tokens.deviceMetadata.randomPassword);

              case 26:
                if (!tokens.signInDetails) {
                  _context2.next = 29;
                  break;
                }

                _context2.next = 29;
                return this.getKeyValueStorage().setItem(authKeys.signInDetails, JSON.stringify(tokens.signInDetails));

              case 29:
                _context2.next = 31;
                return this.getKeyValueStorage().setItem(authKeys.clockDrift, "".concat(tokens.clockDrift));

              case 31:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function storeTokens(_x) {
        return _storeTokens.apply(this, arguments);
      }

      return storeTokens;
    }()
  }, {
    key: "clearTokens",
    value: function () {
      var _clearTokens = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var authKeys;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.getAuthKeys();

              case 2:
                authKeys = _context3.sent;
                _context3.next = 5;
                return Promise.all([this.getKeyValueStorage().removeItem(authKeys.accessToken), this.getKeyValueStorage().removeItem(authKeys.idToken), this.getKeyValueStorage().removeItem(authKeys.clockDrift), this.getKeyValueStorage().removeItem(authKeys.refreshToken), this.getKeyValueStorage().removeItem(authKeys.signInDetails), this.getKeyValueStorage().removeItem(this.getLastAuthUserKey())]);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function clearTokens() {
        return _clearTokens.apply(this, arguments);
      }

      return clearTokens;
    }()
  }, {
    key: "getDeviceMetadata",
    value: function () {
      var _getDeviceMetadata = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(username) {
        var authKeys, deviceKey, deviceGroupKey, randomPassword;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.getAuthKeys(username);

              case 2:
                authKeys = _context4.sent;
                _context4.next = 5;
                return this.getKeyValueStorage().getItem(authKeys.deviceKey);

              case 5:
                deviceKey = _context4.sent;
                _context4.next = 8;
                return this.getKeyValueStorage().getItem(authKeys.deviceGroupKey);

              case 8:
                deviceGroupKey = _context4.sent;
                _context4.next = 11;
                return this.getKeyValueStorage().getItem(authKeys.randomPasswordKey);

              case 11:
                randomPassword = _context4.sent;
                return _context4.abrupt("return", randomPassword ? {
                  deviceKey: deviceKey !== null && deviceKey !== void 0 ? deviceKey : undefined,
                  deviceGroupKey: deviceGroupKey !== null && deviceGroupKey !== void 0 ? deviceGroupKey : undefined,
                  randomPassword: randomPassword
                } : null);

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getDeviceMetadata(_x2) {
        return _getDeviceMetadata.apply(this, arguments);
      }

      return getDeviceMetadata;
    }()
  }, {
    key: "clearDeviceMetadata",
    value: function () {
      var _clearDeviceMetadata = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(username) {
        var authKeys;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.getAuthKeys(username);

              case 2:
                authKeys = _context5.sent;
                _context5.next = 5;
                return Promise.all([this.getKeyValueStorage().removeItem(authKeys.deviceKey), this.getKeyValueStorage().removeItem(authKeys.deviceGroupKey), this.getKeyValueStorage().removeItem(authKeys.randomPasswordKey)]);

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function clearDeviceMetadata(_x3) {
        return _clearDeviceMetadata.apply(this, arguments);
      }

      return clearDeviceMetadata;
    }()
  }, {
    key: "getAuthKeys",
    value: function () {
      var _getAuthKeys = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(username) {
        var _this$authConfig;

        var lastAuthUser;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                assertTokenProviderConfig((_this$authConfig = this.authConfig) === null || _this$authConfig === void 0 ? void 0 : _this$authConfig.Cognito);

                if (!(username !== null && username !== void 0)) {
                  _context6.next = 5;
                  break;
                }

                _context6.t0 = username;
                _context6.next = 8;
                break;

              case 5:
                _context6.next = 7;
                return this.getLastAuthUser();

              case 7:
                _context6.t0 = _context6.sent;

              case 8:
                lastAuthUser = _context6.t0;
                return _context6.abrupt("return", createKeysForAuthStorage(this.name, "".concat(this.authConfig.Cognito.userPoolClientId, ".").concat(lastAuthUser)));

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getAuthKeys(_x4) {
        return _getAuthKeys.apply(this, arguments);
      }

      return getAuthKeys;
    }()
  }, {
    key: "getLastAuthUserKey",
    value: function getLastAuthUserKey() {
      var _this$authConfig2;

      assertTokenProviderConfig((_this$authConfig2 = this.authConfig) === null || _this$authConfig2 === void 0 ? void 0 : _this$authConfig2.Cognito);
      var identifier = this.authConfig.Cognito.userPoolClientId;
      return "".concat(this.name, ".").concat(identifier, ".LastAuthUser");
    }
  }, {
    key: "getLastAuthUser",
    value: function () {
      var _getLastAuthUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var _yield$this$getKeyVal3;

        var lastAuthUser;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.getKeyValueStorage().getItem(this.getLastAuthUserKey());

              case 2:
                _context7.t1 = _yield$this$getKeyVal3 = _context7.sent;
                _context7.t0 = _context7.t1 !== null;

                if (!_context7.t0) {
                  _context7.next = 6;
                  break;
                }

                _context7.t0 = _yield$this$getKeyVal3 !== void 0;

              case 6:
                if (!_context7.t0) {
                  _context7.next = 10;
                  break;
                }

                _context7.t2 = _yield$this$getKeyVal3;
                _context7.next = 11;
                break;

              case 10:
                _context7.t2 = 'username';

              case 11:
                lastAuthUser = _context7.t2;
                return _context7.abrupt("return", lastAuthUser);

              case 13:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getLastAuthUser() {
        return _getLastAuthUser.apply(this, arguments);
      }

      return getLastAuthUser;
    }()
  }]);

  return DefaultTokenStore;
}();

var createKeysForAuthStorage = function createKeysForAuthStorage(provider, identifier) {
  return getAuthStorageKeys(AuthTokenStorageKeys)("".concat(provider), identifier);
};

function getAuthStorageKeys(authKeys) {
  var keys = Object.values(_objectSpread({}, authKeys));
  return function (prefix, identifier) {
    return keys.reduce(function (acc, authKey) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, authKey, "".concat(prefix, ".").concat(identifier, ".").concat(authKey)));
    }, {});
  };
}

export { DefaultTokenStore, createKeysForAuthStorage, getAuthStorageKeys };